import { ComboboxCollection, ComboboxGroup, ComboboxItem, ComboboxList } from '@components/ui/combobox';

import type { FieldItem } from '../../types';

import SelectorHeader from './SelectorHeader';

export default function ContractDetailsSelector({
  contractDetailsItems,
  setSelectedTab,
  search,
  setSearch,
}: {
  contractDetailsItems: FieldItem[];
  setSelectedTab: (tab: null) => void;
  search: string;
  setSearch: (search: string) => void;
}) {
  return (
    <div className="flex flex-col">
      <SelectorHeader
        title="Contract Details"
        onBack={() => setSelectedTab(null)}
        search={search}
        setSearch={setSearch}
      />
      <ComboboxList className="max-h-[calc(var(--available-height)-150px)] shrink-0 overflow-y-auto p-0">
        <ComboboxGroup items={contractDetailsItems}>
          <ComboboxCollection>
            {(item) => (
              <ComboboxItem
                key={item.value}
                value={item}
                className="rounded-none border-b border-gray-100 px-3 py-2 last:border-0"
              >
                {item.label}
              </ComboboxItem>
            )}
          </ComboboxCollection>
        </ComboboxGroup>
      </ComboboxList>
    </div>
  );
}
